import React, { useState } from "react";
import { FaTimes, FaPlus } from 'react-icons/fa';


const MultiValueInput = ({ placeholder = "Add a value...", onChange, onSubmit }) => {
    const [inputValue, setInputValue] = useState("");
    const [values, setValues] = useState([]);

    const handleAddValues = (newValues) => {
        const uniqueValues = newValues
            .map((val) => val.trim())
            .filter((val) => val && !values.includes(val));

        if (uniqueValues.length > 0) {
            const updatedValues = [...values, ...uniqueValues];
            setValues(updatedValues);
            onChange && onChange(updatedValues);
        }
    };

    const handleAddValue = () => {
        handleAddValues([inputValue]);
        setInputValue("");
    };

    const handleRemoveValue = (index) => {
        const updatedValues = values.filter((_, i) => i !== index);
        setValues(updatedValues);
        onChange && onChange(updatedValues);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleAddValue();
        }
    };

    const handlePaste = (e) => {
        const pasteData = e.clipboardData.getData("text");
        
        if (pasteData.includes("\n")) {
            e.preventDefault();
            const newValues = pasteData.split("\n");
            handleAddValues(newValues);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const updatedValues = inputValue.trim() ? [...values, inputValue.trim()] : values;

        onSubmit(updatedValues);

        setInputValue("");
        setValues([]);
    };

    return (
        <div className="flex flex-col items-center gap-4 w-full max-w-lg mx-auto p-4 bg-white border rounded-lg shadow-md">
            <h4 className="self-start text-lg font-semibold px-2 my-2">Add domains</h4>
            <div className="flex flex-wrap gap-2 mb-3">
                {values.map((value, index) => (
                    <div
                        key={index}
                        className="flex items-center px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-md font-medium"
                    >
                        {value}
                        <button
                            type="button"
                            className="ml-2 text-red-500 hover:text-red-700 focus:outline-none"
                            onClick={() => handleRemoveValue(index)}
                            aria-label={`Remove ${value}`}
                        >
                            <FaTimes className="h-3 hover:h-4" />
                        </button>
                    </div>
                ))}
            </div>
            <div className="flex items-center gap-2">
                <input
                    type="text"
                    className="flex-1 w-80 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    placeholder={placeholder}
                />
                <button
                    type="button"
                    className="h-7 w-7 flex justify-center items-center bg-blue-500 text-white rounded-full hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    onClick={handleAddValue}
                >
                    <FaPlus className="w-3 h-3" />
                </button>
            </div>
            <button
                type="submit"
                className="min-w-20 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );
};

export default MultiValueInput;